var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { selectBalancingOutskirtUnlockLevel } from "../balancingSelectors/selectBalancingOutskirts";
import { IdOutskirtBuildings } from "../constants/IdOutskirtBuildings";
import { LimitedActionType } from "../utils/network/generated/protoTypes";
import { utilLimitedActionTime } from "../utils/utilLimitedActionTime";
import { selectWaterTowerBuffedAmount } from "./selectBuffsInfo";
import { selectLimitedActionInfo } from "./selectLimitedActionInfo";
import { selectOutskirtBuildingInfo, selectOutskirtBuildingLevel, } from "./selectOutskirtBuildingInfo";
import { selectPlayerLevel } from "./selectPlayerLevelInfo";
import { mapRecipeIdToRecipeData } from "./selectRecipeInfo";
export var selectWaterTowerInfo = function (state) {
    return selectOutskirtBuildingInfo(state, IdOutskirtBuildings.Watertower);
};
export var selectIsQualifiedForWaterTower = function (state) {
    var level = selectPlayerLevel(state);
    return level >= selectBalancingOutskirtUnlockLevel(IdOutskirtBuildings.Watertower);
};
export var selectWaterTowerResourceInfo = function (state) {
    var waterTowerLevel = selectOutskirtBuildingLevel(state, IdOutskirtBuildings.Watertower);
    var waterTowerInfo = selectWaterTowerInfo(state);
    var recipeForCurrentWaterTowerLevel = parseInt(waterTowerInfo.balancing.outsideBuildingStage[waterTowerLevel - 1].recipeIds, 10);
    var recipeData = mapRecipeIdToRecipeData(state, recipeForCurrentWaterTowerLevel);
    return recipeData.product[0];
};
export var selectWaterTowerResourceAmountInfo = function (state) {
    var waterTowerResource = selectWaterTowerResourceInfo(state);
    var waterTowerResourceBuffedAmount = selectWaterTowerBuffedAmount(state, waterTowerResource.amount);
    return __assign({}, waterTowerResource, { amount: waterTowerResourceBuffedAmount });
};
export var selectWaterTowerProductInfo = function (state) {
    var waterTowerInfo = selectWaterTowerResourceInfo(state);
    return {
        amount: waterTowerInfo.amount.toNumber(),
        resourceId: waterTowerInfo.id,
    };
};
var selectIsWaterReadyForCollection = function (state) {
    var waterTowerLimitedActionInfo = selectLimitedActionInfo(state, LimitedActionType.WATER_TOWER);
    var waterTowerRemainingTime = utilLimitedActionTime.getLimitedActionResetRemainingTime(waterTowerLimitedActionInfo);
    return waterTowerRemainingTime === 0;
};
export var selectWaterTowerCanCollectWater = function (state) {
    return selectIsQualifiedForWaterTower(state) && selectIsWaterReadyForCollection(state);
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectWatertowerInfo.ts
// module id = 252
// module chunks = 3